// extracted by mini-css-extract-plugin
module.exports = {"Container":"📚4-7-0c1Rfp","shape_pill":"📚4-7-02yw1A","shape_squared":"📚4-7-01x4uJ","size_small":"📚4-7-03m1zD"};